import Person, { names as personNames } from '@/common/interfaces/dto/Person';

export interface EmailSignUpUser {
  Person?: Person;
  Email: string;
  AnalyticsPayload?: string;
}

const formNames = {
  UserPerson: 'Person',
  UserEmail: 'Email',
  TermsAndConditions: 'TermsAndConditions',
  NewsletterOptin: 'NewsletterOptin',
  DisneyOptin: 'DisneyOptin',
};

export const names = {
  ...personNames,
  ...formNames,
};
